var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtensionPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0268 0H4.02676V1.14286H5.16961V7.91965C5.16961 7.97154 5.15176 8.02232 5.11939 8.0625L3.62609 9.92857C3.32698 10.303 3.59372 10.8571 4.07252 10.8571H7.45533V15.4286H8.59818V10.8571H11.981C12.4598 10.8571 12.7265 10.303 12.4274 9.92857L10.9341 8.0625C10.9018 8.02232 10.8839 7.97154 10.8839 7.91965V1.14286H12.0268V0ZM9.74104 1.14286H6.31247V7.9308C6.31247 7.976 6.29909 8.02009 6.27453 8.05748L5.40623 9.35881C5.30577 9.51061 5.41403 9.71429 5.59707 9.71429H10.4564C10.6395 9.71429 10.7477 9.51061 10.6473 9.35881L9.77899 8.05748C9.75443 8.02009 9.74104 7.976 9.74104 7.9308V1.14286Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensionPin);
export default __webpack_public_path__ + "static/media/extension-pin.bcb8247216759aa128d11da81468b76a.svg";
export { ForwardRef as ReactComponent };